






































































import {
    BAlert,
    BButton,
    BCard,
    BCardGroup,
    BCardText,
    BForm,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormText,
    BSpinner,
    VBTooltip,
} from "bootstrap-vue";
import DescriptionInputCounter from "@/views/modules/settings/whatsapp-templates/components/descriptionInputCounter.vue";
import { ValidationProvider } from "vee-validate";
import { computed, defineComponent, PropType, watch } from "@vue/composition-api";
import { TemplateInterface } from "@/interfaces/template.interface";
import useChannels from "@/composables/useChannels";
import { PlatformType } from "@/types/platform.type";
import { ProviderType } from "@/types/provider.type";
import ChannelInterface from "@/interfaces/channel.interface";

export default defineComponent({
    components: {
        BButton,
        BSpinner,
        BAlert,
        BFormCheckboxGroup,
        BFormCheckbox,
        ValidationProvider,
        BFormGroup,
        BCard,
        BCardGroup,
        BCardText,
        BForm,
        BFormInput,
        BFormText,
        BFormSelect,
        DescriptionInputCounter,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        lockMetadata: {
            required: false,
            type: Boolean,
        },
        value: {
            required: true,
            type: Object as PropType<TemplateInterface>,
        },
    },

    setup(props, { emit }) {
        const { channels, fetchChannels, isLoaded: isChannelsLoaded } = useChannels();

        const template = computed<TemplateInterface>({
            get: () => props.value,
            set: (value) => emit("input", value),
        });

        const channelIds = computed<number[]>({
            get: () => (props.value.channels ?? []).map((channel) => channel.id),
            set: (channelIds) => {
                emit("input", { ...template.value, channels: channelIds?.map((channelId) => ({ id: channelId })) });
            },
        });

        fetchChannels(
            {
                $or: [
                    {
                        platform: PlatformType.WHATSAPP,
                        provider: ProviderType.MESSAGEBIRD,
                    },
                    {
                        platform: PlatformType.WHATSAPP,
                        provider: ProviderType.WHATSAPP,
                    },
                    {
                        platform: PlatformType.WHATSAPP,
                        provider: ProviderType.BIRD,
                    },
                ],
            },
            ["auth"]
        );

        const channelsWithParsedAuth = computed<Array<ChannelInterface & { parsedAuth: { wabaId: string } }>>(() =>
            channels.value.map((channel) => ({
                ...channel,
                parsedAuth: JSON.parse(channel.auth ?? "{}"),
            }))
        );

        interface WabaChannelsInterface {
            wabaId: string;
            channels: ChannelInterface[];
        }

        // Combine wabaId and channels
        const wabaChannels = computed<WabaChannelsInterface[]>(() =>
            channelsWithParsedAuth.value.reduce<WabaChannelsInterface[]>((wabaChannels, channel) => {
                const currentWabaChannel = wabaChannels.find(
                    (wabaChannel) => wabaChannel.wabaId === channel.parsedAuth.wabaId
                );

                if (currentWabaChannel) {
                    currentWabaChannel.channels.push(channel);

                    return wabaChannels;
                }

                return [
                    ...wabaChannels,
                    {
                        wabaId: channel.parsedAuth.wabaId,
                        channels: [channel],
                    },
                ];
            }, [])
        );

        const wabaSelected = computed({
            get: () => template.value.wabaId,
            set: (value) => {
                template.value.wabaId = value;
            },
        });

        // Set the wabaSelected when the channels are loaded and if it was not set before
        watch(isChannelsLoaded, () => {
            if (!isChannelsLoaded || wabaSelected.value || !wabaChannels.value.length) {
                return;
            }

            wabaSelected.value = wabaChannels.value[0].wabaId;
        });

        const channelsToSelect = computed(() => {
            const selectedWabaChannels = wabaChannels.value.find(
                (wabaChannel) => wabaChannel.wabaId === wabaSelected.value
            );

            if (!selectedWabaChannels) {
                return [];
            }

            return selectedWabaChannels.channels.map((channel) => ({
                text: channel.name,
                value: channel.id,
            }));
        });

        return {
            wabaChannels,
            wabaSelected,
            channelsToSelect,
            isChannelsLoaded,
            template,
            channelIds,
        };
    },
});
